export type LabIcons = 'page-live-doc' | 'suggested-edit';

/**
 * list of icon suffix from @atlaskit/icon/core with a couple of speical cases from @atlaskit/icon-lab/core
 */
export type AllowedIcon =
	| LabIcons
	| 'page'
	| 'video'
	| 'database'
	| 'whiteboard'
	| 'quotation-mark'
	| 'smart-link'
	| 'globe'
	| 'teams'
	| 'goal'
	| 'project'
	| 'heart'
	| 'dashboard'
	| 'work-item'
	| 'work-items'
	| 'roadmap'
	| 'sprint'
	| 'focus-area'
	| 'calendar-plus';

function importIcon(name: AllowedIcon) {
	switch (name) {
		// lab-icons start
		case 'page-live-doc':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-page-live-doc" */
				'@atlaskit/icon-lab/core/page-live-doc'
			);
		case 'suggested-edit':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-suggested-edit" */
				'@atlaskit/icon-lab/core/suggested-edit'
			);
		// lab-icons end
		case 'page':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-page" */
				'@atlaskit/icon/core/page'
			);
		case 'video':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-video" */
				'@atlaskit/icon/core/video'
			);
		case 'database':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-database" */
				'@atlaskit/icon/core/database'
			);
		case 'whiteboard':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-whiteboard" */
				'@atlaskit/icon/core/whiteboard'
			);
		case 'quotation-mark':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-quotation-mark" */
				'@atlaskit/icon/core/quotation-mark'
			);
		case 'smart-link':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-smart-link" */
				'@atlaskit/icon/core/smart-link'
			);
		case 'globe':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-globe" */
				'@atlaskit/icon/core/globe'
			);
		case 'teams':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-teams" */
				'@atlaskit/icon/core/teams'
			);
		case 'goal':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-goal" */
				'@atlaskit/icon/core/goal'
			);
		case 'project':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-project" */
				'@atlaskit/icon/core/project'
			);
		case 'heart':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-heart" */
				'@atlaskit/icon/core/heart'
			);
		case 'dashboard':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-dashboard" */
				'@atlaskit/icon/core/dashboard'
			);
		case 'work-item':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-work-item" */
				'@atlaskit/icon/core/work-item'
			);
		case 'work-items':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-work-items" */
				'@atlaskit/icon/core/work-items'
			);
		case 'roadmap':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-plan" */
				'@atlaskit/icon/core/roadmap'
			);
		case 'sprint':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-sprint" */
				'@atlaskit/icon/core/sprint'
			);
		case 'focus-area':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-focus-area" */
				'@atlaskit/icon/core/focus-area'
			);
		case 'calendar-plus':
			return import(
				/* webpackChunkName: "@atlaskit-internal_async-universal-create-icon-calendar-plus" */
				'@atlaskit/icon/core/calendar-plus'
			);
		default:
			throw new Error(`Icon ${name} not found`);
	}
}

export async function iconLoader(icon: AllowedIcon) {
	try {
		if (!icon) {
			return undefined;
		}
		const iconModule = await importIcon(icon);
		return iconModule ? iconModule.default : undefined;
	} catch (error) {
		return undefined;
	}
}
